import React from "react";

import { LiquidationAlert } from "./components/LiquidationAlert/LiquidationAlert";
import { useLiquidationWarningsController } from "./LiquidationWarnings.controller";

/* Modals are temporarily disabled until stakeholders approve it's usage */
export const LiquidationWarnings = () => {
  const {
    areAlertsInvisible,
    liquidationWarningDetails,
    handleDeposit,
    dismissLiquidationWarning,
  } = useLiquidationWarningsController();

  if (areAlertsInvisible) return null;

  return (
    <>
      {liquidationWarningDetails.map(({ symbol, variant, mmr }) => {
        if (variant === "none") return null;

        return (
          <LiquidationAlert
            mmr={mmr}
            key={symbol}
            symbol={symbol}
            variant={variant}
            actionProps={{
              onClick: () => {
                handleDeposit(symbol);
              },
            }}
            closeIconProps={{
              onClick: () => {
                dismissLiquidationWarning(symbol);
              },
            }}
          />
        );
      })}
    </>
  );
};
